import React, { useEffect, useState } from 'react';
import SharedButton from '../../components/Shared/SharedButton';
import { useTranslation } from 'react-i18next';
import PayrunTable from './PayrunTable';
import CreatePayrun from './CreatePayrun';
import CreatePayroll from './CreatePayroll';
import { useNavigate } from 'react-router-dom';
import useFetchData from '../../hooks/useFetchData';

export default function PayrunMain() {
  const [createDialogVisible, setCreateDialogVisible] = useState(false);
  const [createDialogVisiblee, setCreateDialogVisiblee] = useState(false);
  const { data: payrunData, loading, executeFetch } = useFetchData();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    executeFetch("POST", "payrolls/list", { page: 1, per_page: 10 });
  }, [executeFetch]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "payrolls/list", { page: newPage, per_page: newRowsPerPage });
  };

  const handleRefresh = () => {
    executeFetch("POST", "payrolls/list", { page: 1, per_page: 10 });
  };

  return (
    <>
      <div>
        <div className='flex justify-end gap-2 mb-2'>
          <SharedButton
            label={t('Create Payroll')}
            icon='pi pi-plus'
            onClick={() => navigate('/manager/payrolls/create')}
            className='bg-primary primary-btn'
          />

          <SharedButton
            label={t('GeneratePayrun')}
            icon='pi pi-plus'
            onClick={() => navigate('/manager/payrun/create')}
            className='bg-primary primary-btn'
          />
        </div>
      </div>
      <CreatePayroll
        setCreateDialogVisiblee={setCreateDialogVisiblee}
        createDialogVisiblee={createDialogVisiblee}
        onRefresh={handleRefresh}
      />
      <CreatePayrun
        setCreateDialogVisible={setCreateDialogVisible}
        createDialogVisible={createDialogVisible}
        onRefresh={handleRefresh}
      />
      <PayrunTable
        data={payrunData}
        loading={loading}
        onPageChange={handlePageChange}
        onRefresh={handleRefresh}
      />
    </>
  );
}
